export const N01_GLOBAL_NAV_SECTION_TEMPLATE_ID = 'B6DF10B802BE4D0AA70D95AD5F744CAF';
export const N01_UTILITY_NAV_SECTION_TEMPLATE_ID = '65F952A569AA446F97573F04B1480AC3';
export const TAB_CONTAINER_VALUE = 'tab-container';
export const TAB_CONTENT_CONTAINER_VALUE = 'tab-content-container';
export const ACCORDION_ITEM_CONTAINER = `accordion-item-container`;
export const PROMO_CTA_COMPONENT_NAME = 'C07PromoCTA';
export const HERO_BANNER_CAROUSEL_CONTAINER = 'hero-banner-carousel-container';
export const HERO_BANNER_COMPONENT_NAME = 'B01HeroBanner';
export const LINK_LIST_ITEM_CONTAINER = 'link-list-item-container';
export const REVERSE_ROW_STORIES_CONTAINER = 'reverse-row-stories-container';
export const SIDE_PHOTO_CONTENT_CARD_COMPONENT_NAME = 'C13SidePhotoContentCard';
export const SIDE_PHOTO_CONTENT_CARDS = 'side-photo-content-cards';
export const ICON_CTA_BORDERED_CARDS = 'icon-cta-bordered-cards';
export const HERO_STATISTICS_CONTAINER = 'hero-statistics-container';
export const TRANSLATION_EXCLUDE_FROM_TRANSLATION = 'OneLinkNoTx';
export const MEDIA_GALLERY_CONTAINER = 'media-gallery-container';
export const MEDIA_GALLERY_ITEM_COMPONENT_NAME = 'C43MediaGalleryItem';
export const MULTI_COLUMN_CTA_CONTAINER = 'multi-column-cta-container';
export const MULTI_COLUMN_CONTAINER = 'multi-column-container';
export const ICON_CTA_LEFT_ALIGNED_CARDS = 'icon-cta-left-aligned-cards';
export const ICON_CTA_COLORED_BOX_CARDS = 'icon-cta-colored-box-cards';
export const PROMO_CAROUSEL_CTAS = 'promo-carousel-ctas-{*}';
export const CTA_CONTENT_CARDS = 'cta-content-cards';
export const SIDE_STATISTICS_CONTAINER = 'side-statistics-container';
export const TOP_STATISTICS_CONTAINER = 'top-statistics-container';
export const DATA_ROW_TEMPLATEID = '{4DAE3D45-F22C-452B-AE7B-84A609217996}';
export const HEADER_ROW_TEMPLATEID = '{57BDC0A2-4B6A-4905-91F0-04D282012648}';
export const TABLE_CELL_TEMPLATEID = '{BAD8A088-E30D-46CA-8A48-DC5920CD582D}';
export const ICON_CTA_SIMPLIFIED_CARDS = 'icon-cta-simplified-cards';
export const ALERT_COOKIE = 'alert_dismissed';
export const LOCATION_CARDS = 'location-cards';
export const IMAGE_ASSET_CARDS = 'image-asset-cards';
export const TESTIMONIAL_CARDS = 'testimonial-cards';
export const TESTIMONIAL_CARD_COMPONENT_NAME = 'C44TestimonialCard';
export const NEWS_DETAILS_COMPONENT_NAME = 'C60NewsDetails';
export const BLOG_DETAILS_COMPONENT_NAME = 'C61BlogDetails';
export const NEWS_PAGE_TEMPLATE_ID = '0cda50ff-4e33-4b43-8e68-006d5fb53ea7';
export const BLOG_PAGE_TEMPLATE_ID = 'db774f69-7179-4216-9a62-ead593202fda';
export const DOCTOR_PAGE_TEMPLATE_ID = '80318c2b-d8f8-4946-9aa8-7736665b9bf9';
export const LOCATION_PAGE_TEMPLATE_ID = 'cc719a34-ad0d-4f4b-b040-bb6b3a665f9d';
export const ADVOCATEHEALTHCOM_SCSITE_COOKIE = 'AdvocateHealthCom';
export const ADVOCATECHILDRENSHOSPITALCOM_SCSITE_COOKIE = 'AdvocateChildrensHospitalCom';
export const ADVOCATEHEALTHORG_SCSITE_COOKIE = 'AdvocateHealthOrg';
export const AURORABAYCARECOM_SCSITE_COOKIE = 'AuroraBayCareCom';
export const AURORAHEALTHCAREORG_SCSITE_COOKIE = 'AuroraHealthCareOrg';
export const ATRIUMHEALTHFLOYDHARBINORG_SCSITE_COOKIE = 'AtriumHealthFloydHarbinOrg';
export const WELLNESSADVOCATEHEALTHORG_SCSITE_COOKIE = 'WellnessAdvocateHealthOrg';
/** rootItemIds must be formatted without - or {} to correctly query from GraphQl. */
export const SITE_ROOT_IDS: Record<string, string> = {
  Global: 'FEF03F6BF18E40FD9C449B75C469CA21',
  AdvocateHealthCom: '279E481F80FB46E593C496A4EB056FFD',
  AdvocateChildrensHospitalCom: '564ED9E5D4C342AE892AAB3613A7D931',
  AdvocateHealthOrg: 'FC002B0689D54A2CA70ED1F6802CE86D',
  AuroraBayCareCom: '6A2836D3C9EB48AA937871DFC729F438',
  AuroraHealthCareOrg: 'ED218D516A2149BA99D94C7175A7DAE9',
  AtriumHealthFloydHarbinOrg: '9C5093998D2B4A17A48D463E073A29FC',
  WellnessAdvocateHealthOrg: '46C5F85C81824B2D92F784C0DADB3B24',
};
